import FieldsCollection from "../../../../../../fields3/collection/base/fields-collection"
import {FieldType} from "../../../../../../fields3/field-type"
import ProjectUserFull from "../../../../../../model2/project-user/project-user-full";

export default function ProjectUser_initWorkspaceUserFields(projectUser: ProjectUserFull) {
    return new FieldsCollection([
        {
            fieldId     : 'access',
            type        : FieldType.WORKSPACE_ACCESS,
            minAccess   : projectUser.minAccess
        },
        {
            fieldId     : 'watchAll',
            type        : FieldType.TOGGLE
        },
    ])
}
